import { render } from "./service-categories.vue?vue&type=template&id=72d9974a&scoped=true"
import script from "./service-categories.vue?vue&type=script&lang=js"
export * from "./service-categories.vue?vue&type=script&lang=js"

import "./service-categories.vue?vue&type=style&index=0&id=72d9974a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d9974a"]])

export default __exports__